export const toBoolComparator = (cmp) => (a, b) => cmp(a, b) === 0;
export const scalarCmp = (a, b) => a === b;
export const arrCmp = (cmp = scalarCmp) => (a, b) => a === b || Boolean(a && b && a.length === b.length && a.every((_, i) => cmp(_, b[i])));
export const objCmp = (cmp) => (a, b) => a === b ||
    Boolean(a &&
        b &&
        Object.keys(a).length === Object.keys(b).length &&
        Object.entries(a).every(([key, value]) => cmp(value, b[key])));
export function combineBoolCmps(...comparators) {
    return (a, b) => comparators.some((cmp) => cmp(a, b));
}
//# sourceMappingURL=BoolComparator.js.map